import jwt_decode from 'jwt-decode';
import { resolveCognitoRoles } from '../utils/cognitoRoles';
import {
  SHOW_REAUTH_MODAL,
  HIDE_REAUTH_MODAL,
  ADD_PENDING_REQUEST,
  CLEAR_PENDING_REQUESTS,
  SET_AUTH_LOADING
} from '../actions/authActions';

const INTIAL_STATE = {
  isSignedIn: null,
  everSignedIn: null,
  userId: null,
  cognitoGroups: null,
  cognitoMod: 'No',
  cognitoDeveloper: false,
  cognitoTester: false,
  cognitoObserver: false,
  testerMod: 'No',
  accessToken: null,
  uid: null,
  email: null,
  // Re-authentication state
  reauthRequired: false,
  pendingRequests: [],
  isLoading: true
};

const loggedReducer = (state = INTIAL_STATE, action) => {
  const devOrStageOrProd = process.env.REACT_APP_DEV_OR_STAGE_OR_PROD;
  switch (action.type) {
    case 'SET_TESTER_MOD':
      return { ...state, testerMod: action.payload }
    case 'SIGN_IN':
      const jsonToken = jwt_decode(action.payload.accessToken);
      // Cognito uses 'cognito:groups' claim for groups (same group names as Okta).
      // Roles resolve through the explicit, tested mapping in utils/cognitoRoles:
      // <Mod>Observer groups yield a read-only role scoped to the sponsoring MOD
      // and are never fed through the legacy prefix inference (SCRUM-6431).
      const groups = jsonToken['cognito:groups'] || jsonToken.Groups || [];
      const roles = resolveCognitoRoles(groups, devOrStageOrProd);
      return {
        ...state,
        isSignedIn: true,
        everSignedIn: true,
        userId: action.payload.userId,
        accessToken: action.payload.accessToken,
        testerMod: 'No',
        cognitoMod: roles.mod,
        cognitoDeveloper: roles.isDeveloper,
        cognitoTester: roles.isTester,
        cognitoObserver: roles.isObserver,
        cognitoGroups: groups,
        uid: jsonToken.sub || jsonToken.uid,
        email: action.payload.email,
        // Clear re-auth state on successful sign in
        reauthRequired: false,
        pendingRequests: [],
        isLoading: false
      }
    case 'SIGN_OUT':
      return {
        ...state,
        isSignedIn: false,
        userId: null,
        cognitoGroups: null,
        cognitoMod: 'No',
        cognitoDeveloper: false,
        cognitoTester: false,
        cognitoObserver: false,
        testerMod: 'No',
        uid: null,
        accessToken: null,
        email: null,
        reauthRequired: false,
        pendingRequests: [],
        isLoading: false
      }
    case SHOW_REAUTH_MODAL:
      return { ...state, reauthRequired: true }
    case HIDE_REAUTH_MODAL:
      return { ...state, reauthRequired: false }
    case ADD_PENDING_REQUEST:
      return {
        ...state,
        pendingRequests: [...state.pendingRequests, action.payload]
      }
    case CLEAR_PENDING_REQUESTS:
      return { ...state, pendingRequests: [] }
    case SET_AUTH_LOADING:
      return { ...state, isLoading: action.payload }
    default:
      return state;
  }
};

export default loggedReducer;
